<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="faq-labels-table"
            :items="tableData"
            :fields="tagFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-tag"
                    v-b-modal="'add-faq-label-modal'"
                    type="button"
                    variant="primary"
                    label="Nieuwe label toevoegen">
                    Nieuw Tags
                </b-button>
            </template>

            <template #cell(color)="data">
                <div
                    class="color-icon"
                    :style="cssVars(data.item.color)">
                    <i
                        class="fas fa-circle"
                        v-b-tooltip.hover
                        :title="`Kleurcode: ${data.item.color}`"></i>
                </div>
            </template>

            <template v-slot:cell(action)="data">
                <div class="management-actions">
                    <b-button
                        class="btn-edit btn-edit-faq-tag btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="editAfaqStatusTag(data.item)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-faq-tag"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="deleteStatusTag(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-add-afaq-modal-component
            @updateTags="addTag($event)"
            ref="add-faq-label-modal">
        </design-2021-add-afaq-modal-component>

        <design-2021-edit-afaq-modal-component
            @updateTags="updateTag($event)"
            ref="edit-faq-label-modal">
        </design-2021-edit-afaq-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-admin-afaq-index-tags-component',
    props: ['afaqTagsIn'],
    data() {
        return {
            afaqTags: this.afaqTagsIn,
            tagFields: [
                {
                    key: 'name',
                    value: 'naam',
                },
                {
                    key: 'color',
                    value: 'color',
                },
                {
                    key: 'action',
                    value: 'actie',
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.afaqTags;
        },
    },
    methods: {
        editAfaqStatusTag(tag) {
            this.$refs['edit-faq-label-modal'].show(tag);
        },

        addTag(tag) {
            this.afaqTags.push(tag);
            this.$emit('updateTags', this.afaqTags);
        },
        updateTag(tag) {
            this.afaqTags = this.afaqTags.map((afaqTag) => {
                if (afaqTag.id === tag.id) {
                    const newTag = { ...afaqTag, ...tag };
                    return newTag;
                } else {
                    return afaqTag;
                }
            });
            this.$emit('updateTags', this.afaqTags);
        },

        deleteStatusTag(tagId) {
            this.alert
                .confirm('apprentice faq label verwijderen', 'Weet je zeker dat je dit label wil verwijderen?')
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.afaqTagsDelete(tagId)).then(
                        (response) => {
                            this.afaqTags = this.afaqTags.filter((item) => item.id !== tagId);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        cssVars(color) {
            return {
                '--category-color': color,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.color-icon {
    font-size: $base-font-size;

    i {
        color: var(--category-color);
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .faq-labels-table ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters,
            .options {
                flex: 0 1 auto;
            }

            .apprentice-table-filters {
                margin-bottom: 0;

                div.search {
                    width: 250px;
                }
            }
        }
    }
}
</style>
